<template>
    <v-list class="soli-btn-list"
        ><v-list-item v-for="item in items" :key="item.value">
            <SoliBtn
                block
                outlined
                :text="item.name"
                color="contrast--text"
                class="my-1"
                @click="$emit('input', item)"
            />
        </v-list-item>
    </v-list>
</template>

<script>
export default {
    props: {
        items: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {};
    },
};
</script>

<style></style>
